import AdminClient from '../client/AdminClient';

class AdminService {
    static registerVisit(id, type, session) {
        return AdminClient.post(`/v1/admin/profile_visits`, session, {id, type});
    }

    static async aums(session) {
        return AdminClient.get(`/v1/admin/aum_ranges/all`, session);
    }

    static async countries(session) {
        return AdminClient.get(`/v1/admin/countries/all`, session);
    }

    static async riaCountries(session) {
        return AdminClient.get(`/v1/admin/ria_countries/all`, session);
    }

    static async countriesByRegion(session) {
        return AdminClient.get(`/v1/admin/countries/by_region`, session);
    }

    static async states(session) {
        return AdminClient.get(`/v1/admin/states/us_states`, session);
    }

    static async regions(session) {
        return AdminClient.get(`/v1/admin/regions/fintrx_data`, session);
    }

    static async riaCities(session) {
        return AdminClient.get(`/v1/admin/ria_cities/all`, session);
    }

    static async geographicFocuses(session) {
        return AdminClient.get(`/v1/admin/geographic_focuses/all`, session);
    }

    static async strategyFocuses(session) {
        return AdminClient.get(`/v1/admin/strategies/all`, session);
    }

    static async assetClassFocuses(session) {
        return AdminClient.get(`/v1/admin/asset_class_focuses/all`, session);
    }

    static async industryWealthOrigins(session) {
        return AdminClient.get(`/v1/admin/industry_wealth_origins/all`, session);
    }

    static async investmentStyles(session) {
        return AdminClient.get(`/v1/admin/investment_styles/fintrx_data`, session);
    }

    static async investmentStages(session) {
        return AdminClient.get(`/v1/admin/investment_stages/fintrx_data`, session);
    }

    static async contactResponsibilities(session) {
        return AdminClient.get(`/v1/admin/contact_responsibilities/all`, session);
    }

    static async investorTypes(session) {
        return AdminClient.get(`/v1/admin/investor_types/fintrx_data`, session);
    }

    static async relationships(session) {
        return AdminClient.get(`/v1/admin/relationships/all`, session);
    }

    static async itemStages(session) {
        return AdminClient.get(`/v1/admin/item_stages/all`, session);
    }

    static async cities(session) {
        return AdminClient.get(`/v1/admin/cities/cities_for_affinity`, session);
    }

    static async realEstateInvestments(session) {
        return AdminClient.get(`/v1/admin/real_estate_investment_history`, session);
    }

    static async foundationStages(session) {
        return AdminClient.get(`/v1/admin/foundation_stages`, session);
    }

    static async investmentStrategies(session) {
        return AdminClient.get(`/v1/admin/foundation_investment_strategies/all`, session);
    }

    static async validateEmail(session, email, entityData) {
        return AdminClient.get(`/v1/admin/emails/validate`, session, {
            email: email,
            entity: entityData
        });
    }

    static async flagEmailValidation(session, params) {
        return AdminClient.post('/v1/admin/emails/flag', session, params)
    }

    static async emailCheckByEntity(session, entity_type, entity_id, email_field) {
        return AdminClient.get('/v1/admin/email_checks/by_entity', session, {
            entity_type: entity_type,
            entity_id: entity_id,
            email_field: email_field
        })
    }
}

export default AdminService;